import { useIntl } from "react-intl";
import { BRAND_COLOR } from "../constants";
import { toast } from "react-toastify";

type Props = {
	referenceNumber: string;
};

/**
 * Only render reference number in a styled container.
 * @returns
 */
export default function ReferenceNumberContainer({ referenceNumber }: Props) {
	const intl = useIntl();

	return (
		<div
			style={{ backgroundColor: BRAND_COLOR }}
			className="text-white text-center fw-bold py-2 mb-2 rounded"
			onClick={(e) => {
				e.stopPropagation();
				navigator.clipboard.writeText(referenceNumber);
				toast.success(intl.formatMessage({ id: "copied_to_clipboard" }, { text: referenceNumber }));
			}}
		>
			<p style={{ letterSpacing: "1px" }} className="mb-0 text-uppercase">
				<i className="fas fa-copy"></i> {referenceNumber}
			</p>
		</div>
	);
}
